/**
 * GENERATED CODE - DO NOT MODIFY
 */
import { type HeadersMap, XRPCError } from '@atproto/xrpc'
import { type ValidationResult, BlobRef } from '@atproto/lexicon'
import { CID } from 'multiformats/cid'
import { validate as _validate } from '../../../../lexicons.js'
import {
  type $Typed,
  is$typed as _is$typed,
  type OmitKey,
} from '../../../../util.js'
import type * as ToolsOzoneQueueDefs from './defs.js'

const is$typed = _is$typed,
  validate = _validate
const id = 'tools.ozone.queue.updateQueue'

export type QueryParams = {}

export interface InputSchema {
  /** ID of the queue to update */
  queueId: number
  /** New display name for the queue */
  name?: string
  /** Enable or disable the queue */
  enabled?: boolean
  /** Optional description of the queue */
  description?: string
  /** Policy keys to recommend when actioning reports in this queue */
  recommendedPolicies?: string[]
}

export interface OutputSchema {
  queue: ToolsOzoneQueueDefs.QueueView
}

export interface CallOptions {
  signal?: AbortSignal
  headers?: HeadersMap
  qp?: QueryParams
  encoding?: 'application/json'
}

export interface Response {
  success: boolean
  headers: HeadersMap
  data: OutputSchema
}

export class InvalidRecommendedPoliciesError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export function toKnownErr(e: any) {
  if (e instanceof XRPCError) {
    if (e.error === 'InvalidRecommendedPolicies')
      return new InvalidRecommendedPoliciesError(e)
  }

  return e
}
